import { errorToString, ITenant } from "@oneethos/shared"
import { useApi } from "../hooks"
import TenantForm from "./tenant-form"

export const TenantSettings = () => {
  const { fetching, data, error } = useApi<ITenant>('/tenant')

  if (fetching) {
    return <div>Loading...</div>
  }

  if (error) {
    return <div className="alert alert-danger">{errorToString(error)}</div>
  }

  return <div className="tenant-settings">
    <h4>Tenant</h4>
    <TenantForm initialConfig={data} />
  </div>
}

export default TenantSettings